import { Pipe, PipeTransform } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { TranslationHelperService } from '../services/translations/translation-helper.service';

@Pipe({
  standalone: true,
  name: 'level',
  pure: true
})
export class LevelNamePipe implements PipeTransform {
  constructor(
    private translationHelper: TranslationHelperService,
  ) {}

  transform(value: any, prefix: string = 'area.level.'): Observable<string> {
    const key = (prefix ?? '') + value;

    return this.translationHelper.get(key).pipe(
      map(translation => (translation === key ? value : translation)),
      catchError(() => of(value))
    );
  }
}
